var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('clicked')}}},[_c('img',{attrs:{"src":_vm.image,"height":_vm.iconHeight,"alt":_vm.$t('digitalWallet.apple')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }